<template>

  <router-link tag="div" :to="{path:'/admin/forum/postsPage/postsContent',query:{'searcharticle':item.ID}}" class="ant-row ant-row-space-between ant-row-middle reply" v-for="(item,index) in pushData" :key="index">
    <div>
      <div class="reply-title">{{item.Title}}</div>
      <span class="reply-title-content">
        <span>发布于{{item.CreateTime}}</span>
        <span>&nbsp;·&nbsp;浏览:{{item.ViewCount}}</span>
      </span>
    </div>
    <div class="bubble">{{item.ReplyCount}}</div>
  </router-link>

</template>
<script>
import { defineComponent, reactive, toRefs,ref } from 'vue';
import Qs from 'qs';
export default defineComponent({
  props:{
    pushData:{
      type: Array,
      default:() => []
      }
  },
  setup() {
    const replyList = reactive([{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999},{title:'人脸识别出现错误，请帮忙',replyContent:'人脸识别不支持微信',count:999}]);
    return{
      replyList,
    }
  },
  mounted(){
    // this.findArticle()
  },
  methods:{
    findArticle(){
      let params = {
          "UserID":this.$store.state.userID,// ,
          // "Creator": "",
          "currentPage":this.tablePager.currentPage,
          "pageSize":this.tablePager.pageSize
        }
      this.$api.formsAPI.getForumArticle(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          this.replyList = res.data.Data.dataTable;

          console.log(res.data.Data)
          // this.$store.commit('updateSearchData','');
          this.tablePager.totalResult = res.data.Data.totalResult;
          this.tablePager.currentPage = res.data.Data.currentPage;
          this.tablePager.pageSize = res.data.Data.pageSize;
          // this.$emit('postsRes',res.data.Data)
        })
        .catch(error => {
          console.log(error);
        })

    },
  }
})
</script>
<style src="../../forum/css/antd.css"></style>
<style scoped lang="scss">
.reply{
    padding:15px;
    border-bottom: 1px solid #ddd;
    .reply-title{
      max-width: 400px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #555666;
      &-content{
            font-size: 13px;
      color: #999;
      }
    }
  }

  .bubble{
  position: relative;
  display: inline-block;
  vertical-align: middle;

  padding: 3px 8px;
  background-color: #f0f7ff;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  font-size: 13px;
  color: #333;
  line-height: normal;
}
.bubble::before{
      content: "";
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    left: -8px;
    display: inline-block;
    width: 0;
    height: 0;
    border-width: 4px;
    border-style: solid;
    border-color: transparent #ebf2fa transparent transparent;
}
</style>
